exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tout-le-monde .btn-secondary{color:#5894b4}.dest-select .btn{background-color:#e8b543!important;border-color:#e8b543!important}.dest-select .selectedDest{background-color:#e8b543}.dest-select ul{max-height:50vh;overflow-y:auto}", ""]);

// exports
